<div class="banner d-none d-lg-flex" role="banner">
  <div class="container">
    <div class="title-wrapper">
      <img src="assets/images/banners/Welcome.png" alt="" />
    </div>
  </div>
</div>
<div class="bg-primary member-container d-lg-none">
  <div class="container">
    <ng-container *ngIf="memberDetails$ | async as member">
      <div class="member-name">
        <h5 class="member-title text-white mb-0">{{ member.FirstName }} {{ member.Surname }}</h5>
        <span class="member-subtitle font-size-12 text-white">
          <ng-container *inPopulation="[populations.Guardian]">
            {{ 'member.product.code' | translate }}
          </ng-container>
        </span>
      </div>
    </ng-container>
  </div>
</div>

<div class="mobile-content-wrapper">
  <div class="container order-lg-3 order-3">
    <div class="border rounded overflow-hidden guardian-info-card">
      <div class="guardian-info-image-container bg-primary">
        <img src="assets/images/jr_jays_logo.png" draggable="false" />
      </div>
      <div class="guardian-info-container bg-white">
        <h2 class="guardian-info-title">
          {{ 'guardian.page.info.title' | translate : { fgbdefault: 'JR.JAYS CLUB MEMBERSHIP' } }}
        </h2>
        <div
          class="guardian-info-text-wrapper font-size-14"
          [innerHTML]="'guardian.page.info' | translate | markdownTranslate"
        ></div>
        <button
          (click)="confirmRegisterModal(confirmRegister)"
          class="btn btn-primary btn-guardian text-center text-white mt-auto"
        >
          {{ 'guardian.page.registerbutton' | translate : { fgbdefault: 'Register as a Guardian' } }}
        </button>
      </div>
    </div>
    <!-- Announcements -->
    <div class="row">
      <div class="col-12">
        <fgbcl-announcements></fgbcl-announcements>
      </div>
    </div>
  </div>
</div>

<!--Confirm modal to become a guardian-->
<ng-template #confirmRegister let-modal>
  <div class="register-guardian-modal" ngbAutofocus>
    <div class="register-guaridan-modal-header">
      <h4>
        {{ 'guardian.page.register.guardian.modal.title' | translate : { fgbdefault: 'Guardian' } }}
      </h4>
    </div>
    <div class="register-guardian-modal-body">
      <p class="font-size-14">
        {{ 'guardian.page.confirminfo' | translate : { fgbdefault: 'Are you sure you wish to become a Guardian?' } }}
      </p>
    </div>
    <div class="modal-footer d-flex justify-content-end mt-auto w-100 font-size-14">
      <button class="btn btn-cancel text-danger fw-bold" (click)="modal.dismiss()">Cancel</button>
      <button class="btn btn-success btn-confirm fw-bold" (click)="becomeGuardian(); modal.dismiss()">Confirm</button>
    </div>
  </div>
</ng-template>
